module.exports = __webpack_public_path__ + "img/ch13_05_公园放风筝.1ff23733.jpg";